import { useStatefulRef as r } from "@bedrock-layout/use-stateful-ref";
import s, { useRef as c } from "react";

function o(t) {
  var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isStateful: !0
  };
  var n = r(null),
      f = c(null),
      e = u.isStateful ? n : f;
  return s.useEffect(function () {
    !t || (typeof t == "function" ? t(e.current) : t.current = e.current);
  }), e;
}

export { o as default, o as useForwardedRef };